import api from '@/services/api';

export function fetchBaiduAifanfanOverview() {
  return api.post('/baidu-aifanfan/overview', {}).then((res) => res.data);
}

export function fetchBaiduAifanfanLeadList(data) {
  return api.post('/baidu-aifanfan/leads/list', data).then((res) => res.data);
}

export function fetchBaiduAifanfanReviewerOptions(data) {
  return api.post('/user/list', data).then((res) => res.data);
}

export function fetchBaiduAifanfanLeadColumns() {
  return api.post('/baidu-aifanfan/leads/columns/query', {}).then((res) => res.data);
}

export function saveBaiduAifanfanLeadColumns(columns) {
  return api.post('/baidu-aifanfan/leads/columns/save', { columns }).then((res) => res.data);
}

export function fetchBaiduAifanfanLeadDetail(id) {
  return api.post(`/baidu-aifanfan/leads/${id}`, {}).then((res) => res.data);
}

export function fetchBaiduAifanfanLeadConversation(id) {
  return api.post(`/baidu-aifanfan/leads/${id}/conversation`, {}).then((res) => res.data);
}

export function approveBaiduAifanfanLead(id, data) {
  return api.post(`/baidu-aifanfan/leads/${id}/review-approve`, data).then((res) => res.data);
}

export function rejectBaiduAifanfanLead(id, data) {
  return api.post(`/baidu-aifanfan/leads/${id}/review-reject`, data).then((res) => res.data);
}

export function linkBaiduAifanfanLeadStudent(id, data) {
  return api.post(`/baidu-aifanfan/leads/${id}/link-student`, data).then((res) => res.data);
}

export function fetchBaiduAifanfanConfig(data) {
  return api.post('/baidu-aifanfan/config/query', data).then((res) => res.data);
}

export function saveBaiduAifanfanConfig(data) {
  return api.post('/baidu-aifanfan/config/save', data).then((res) => res.data);
}

export function fetchBaiduAifanfanCallbackLogs(data) {
  return api.post('/baidu-aifanfan/callback/list', data).then((res) => res.data);
}

export function retryBaiduAifanfanCallback(id) {
  return api.post(`/baidu-aifanfan/callback/${id}/retry`, {}).then((res) => res.data);
}

export function retryBaiduAifanfanCallbackBatch(ids) {
  return api.post('/baidu-aifanfan/callback/retry-batch', { ids }).then((res) => res.data);
}

export function fetchPromotionAccountOptions() {
  return api.post('/promotion-account/list', { disabled: false, page: 1, pageSize: 999 }).then((res) => res.data);
}
